import React, { PropTypes, Component } from 'react';
import { loadMoreWebsiteEntityFromCategory } from '../actions/HomeLoadCreator';
import Loader from 'react-loader';

class EntitiesListHorizontolWebsiteContainer extends Component {
  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }

  static contextTypes = {
    executeAction: React.PropTypes.func
  }

  render() {
    if (!Object.keys(this.props.entities).length) {
      return null;
    }
    const entities = this.props.entities;
    var entitySplit = entities.name.split('/');
    var entityname = entitySplit[entitySplit.length - 1];
    return (
      <div>
        <div className="entity-container">
          <i className="sprite-red sprite-Trending"></i>
          <text className="container-title">
            <span>Top Rated</span>
            { entities.name }
            <span>Websites</span>
          </text>
          <div className="browse-all">browse all</div>
          <div className="slider-container">
            <span className="left-arrow" onClick={ this.prevloadMore.bind(this, {
                                                     name: entities.name,
                                                     type: entities.type,
                                                     id: entities.id,
                                                     obj: entities
                                                   }) }>
                                          <i className="icon-angle-left" style={ { "font-size": "2em" } }></i>
                                      </span>
            <span className="right-arrow" onClick={ this.loadMore.bind(this, {
                                                      name: entities.name,
                                                      type: entities.type,
                                                      id: entities.id,
                                                      obj: entities
                                                    }) }>
                                          <i className="icon-angle-right" style={ { "font-size": "2em" } }></i>
                                      </span>
          </div>
          <div className="entity-maincarousel">
            <ul className="entity_container item-padding" id={ entities.id }>
              { entities.entitiesList.map(function(entity) {
                  return (
                    <li>
                      <a href={ "/website/" + encodeURIComponent(entity.title) }>
                        <div className="website-container">
                          <iframe className="website-image" src={ "http://www." + entity.title } width='100%' />
                          <div className="entity-container-title">
                            <div className="entity-container-titlename">
                              { entity.title.slice(0, 20) + '..' }
                            </div>
                            <div className="entity-container-rating">
                              <span className="rating" style={ { "float": "left", "margin-right": "1em", "margin-top": "1em" } }>
                                                                                                                                                <input type="radio" id="star5" name="rating" value="5" />
                                                                                                                                                <label className="empty" for="star5" title="Awesome - 5 stars"></label>
                                                                                                                                                <input type="radio" id="star4" name="rating" value="4" />
                                                                                                                                                <label className="full" for="star4" title="Pretty good - 4 stars"></label>
                                                                                                                                                <input type="radio" id="star3" name="rating" value="3" />
                                                                                                                                                <label className="full" for="star3" title="Meh - 3 stars"></label>
                                                                                                                                                <input type="radio" id="star2" name="rating" value="2" />
                                                                                                                                                <label className="full" for="star2" title="Kinda bad - 2 stars"></label>
                                                                                                                                                <input type="radio" id="star1" name="rating" value="1" />
                                                                                                                                                <label className="full" for="star1" title="Sucks big time - 1 star"></label>
                                                                                                                                            </span>
                              <div className="entity-container-reviewsbtn">100 reviews</div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </li>
                    );
                }) }
            </ul>
          </div>
        </div>
      </div>
      );
  }
  prevloadMore(entities) {
    var containerheight = document.getElementById(entities.id).style.marginLeft;
    containerheight = containerheight.slice(0, -2);
    if (containerheight < 0) {
      containerheight = parseInt(containerheight) + 119; //or += value
      document.getElementById(entities.id).style.marginLeft = containerheight + "em";
    } else {
      document.getElementById(entities.id).style.marginLeft = "0em";
    }

  }
  loadMore(entities) {
    this.context.executeAction(loadMoreWebsiteEntityFromCategory, entities);
    var entitywidth = document.getElementById(entities.id).childNodes.length * 32;
    document.getElementById(entities.id).style.width = entitywidth + "em";
    var containerheight = document.getElementById(entities.id).style.marginLeft;
    containerheight = containerheight.slice(0, -2);
    if (containerheight <= -119) {
      containerheight -= 119; //or += value
      if (containerheight >= -entitywidth) {
        document.getElementById(entities.id).style.marginLeft = containerheight + "em";
      }
    } else {
      document.getElementById(entities.id).style.marginLeft = "-119em";
    }
  }
}
module.exports = EntitiesListHorizontolWebsiteContainer;


// WEBPACK FOOTER //
// ./src/components/EntitiesListHorizontolWebsiteContainer.js